import React from "react";
import { Sparkles, Bed, Bath, Utensils, Sofa, Refrigerator, Shirt, Wind, Droplets } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const SERVICES = [
  { i: <Bed />, t: "Bedroom cleaning", d: "Bed making, dusting, vacuuming, surface sanitizing." },
  { i: <Bath />, t: "Bathroom cleaning", d: "Toilet, shower, sink, floors and mirrors deep-cleaned." },
  { i: <Utensils />, t: "Kitchen cleaning", d: "Counters, sink, stovetop, exterior of appliances." },
  { i: <Sofa />, t: "Living room", d: "Dusting, vacuuming, tidying common surfaces." },
  { i: <Wind />, t: "Dusting & vacuuming", d: "Top-to-bottom dust removal on every surface." },
  { i: <Droplets />, t: "Mopping & sanitizing", d: "Floors mopped with safe disinfectants." },
  { i: <Shirt />, t: "Laundry folding", d: "Optional add-on — folded and stacked, ready to wear." },
  { i: <Refrigerator />, t: "Fridge & oven", d: "Deep clean inside and out — add as you need." },
  { i: <Sparkles />, t: "Move-in & move-out", d: "Top-to-bottom deep cleans for transitions." },
];

export default function Services() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      <Badge variant="outline" className="mb-3">Services</Badge>
      <h1 className="font-display text-4xl sm:text-5xl font-bold text-primary max-w-3xl">Everything we clean, exactly the way you'd hope a professional would.</h1>
      <p className="mt-4 text-muted-foreground max-w-2xl">Build your plan by mixing any of the services below. Each visit ends with a full report and before/after photos.</p>

      <div className="grid md:grid-cols-3 gap-4 mt-12">
        {SERVICES.map((s) => (
          <Card key={s.t} className="border-border/60 hover:-translate-y-0.5 transition-transform">
            <CardContent className="p-6 space-y-3">
              <div className="w-11 h-11 rounded-xl bg-secondary/10 text-secondary flex items-center justify-center">{s.i}</div>
              <div className="font-display font-semibold text-lg text-primary">{s.t}</div>
              <p className="text-sm text-muted-foreground">{s.d}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
